export const getSelectedKitchenId = (kitchenName, kitchens) =>
  kitchenName && kitchens.find(kitchen => kitchen.name === kitchenName).id
